module.exports = __webpack_public_path__ + "static/img/guidance5.9ff234d4.webp";